<script setup>
import './index-four-section.scss'
import { ref, nextTick, onMounted, computed, watch, onBeforeUnmount } from 'vue'
import { useStore } from 'vuex'
const store = useStore()

import { gsap, Power2, Expo, Power1, Linear } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import LoaderVideo from '@/components/Loader/loader-video.vue'
gsap.registerPlugin(ScrollTrigger)

const thisSect = ref()
const sectHolder = ref()
const serviceNavElem = ref()
const followerQuad = ref()
const contentElem = ref()
const isFollowerActive = ref(false)
let xTo, yTo

const isAllLoaded = computed(() => {
	return store.getters['preloader/isAllLoaded']
})

const activedElem = ref(3)

watch(
	() => isAllLoaded.value,
	(allLoaded) => {
		if (allLoaded) {
			animations()
		}
	},
	{ immediate: false }
)

onMounted(() => {
	console.log(`mounted index four section`)
	scrollingAnimationsInit()
	if (isAllLoaded.value) {
		animations()
	}
})

onBeforeUnmount(() => {
	if (serviceNavElem.value) {
		serviceNavElem.value.removeEventListener('mousemove', serviceMouseMove)
		serviceNavElem.value.removeEventListener('mouseleave', serviceMouseLeave)
	}
})

function animations() {
	const TL = gsap.timeline({
		scrollTrigger: {
			trigger: thisSect.value,
			start: 'top bottom',
			end: 'bottom top',
			pin: sectHolder.value,
			invalidateOnRefresh: true
		}
	})
}

function scrollingAnimationsInit() {
	if (!followerQuad.value || !serviceNavElem.value) return

	xTo = gsap.quickTo(followerQuad.value, 'x', { delay: 0.3, ease: 'power3' })
	yTo = gsap.quickTo(followerQuad.value, 'y', { ease: 'power3' })

	serviceNavElem.value.addEventListener('mousemove', serviceMouseMove)
	serviceNavElem.value.addEventListener('mouseleave', serviceMouseLeave)

	// Начальное позиционирование по вертикали на пункте Sites (индекс 3)
	let y = 10
	yTo(y)
}

function serviceMouseMove(e) {
	if (!serviceNavElem.value) return
	let boundingRect = serviceNavElem.value.getBoundingClientRect()
	let relX = e.pageX - boundingRect.left
	let relY = e.pageY - boundingRect.top
	let scrollTop = window.pageYOffset || document.documentElement.scrollTop
	let x = relX - boundingRect.width / 2
	let y = relY - boundingRect.height / 2 - scrollTop
	xTo(x)
	yTo(y)
	isFollowerActive.value = true
}

function serviceMouseLeave() {
	if (!serviceNavElem.value) return
	activedElem.value = 3
	xTo(0)
	yTo(10)
	isFollowerActive.value = false
}

function handleMouseEnter(activedNumber) {
	activedElem.value = activedNumber
}
</script>

<template>
	<div class="index-four-section" ref="thisSect">
		<div class="sect-holder" ref="sectHolder">
			<div class="sect-content-box" ref="contentElem">
				<div class="top-header-wrap">
					<div class="top-left-box">
						<span class="insp-text">Our inspiration <br />design love</span>
						<span class="wedo-text">wedo</span>
					</div>
					<div class="top-center-box">
						<span class="since-text">Since 2001</span>
					</div>
				</div>

				<div class="container">
					<div class="navi-box">
						<div class="follower-quad" ref="followerQuad" :class="{ active: isFollowerActive }">
							<div class="follower-holder">
								<div class="pic">
									<loader-video path="assets/video" file-name="service-video02" :mp4="true" :autoplay="true" :loop="true" />
								</div>
								<div class="text-wrap">
									<span class="text-item" :class="{ active: activedElem === 1 }">Design creation</span>
									<span class="text-item" :class="{ active: activedElem === 2 }">Branding creation</span>
									<span class="text-item" :class="{ active: activedElem === 3 }">Web sites creation</span>
									<span class="text-item" :class="{ active: activedElem === 4 }">Motion 3d objects</span>
									<span class="text-item" :class="{ active: activedElem === 5 }">Mobile applications</span>
								</div>
							</div>
						</div>

						<div class="service-nav">
							<div class="item">
								<div class="item-holder"><span>Design</span></div>
							</div>
							<div class="item">
								<div class="item-holder"><span>Branding</span></div>
							</div>
							<div class="item">
								<div class="item-holder"><span>Sites</span></div>
							</div>
							<div class="item">
								<div class="item-holder"><span>3D Motion</span></div>
							</div>
							<div class="item">
								<div class="item-holder"><span>Mobile app.</span></div>
							</div>
						</div>

						<div class="service-nav duplicated" ref="serviceNavElem">
							<div class="item" :class="{ active: activedElem === 1 }" @mouseenter="handleMouseEnter(1)">
								<div class="item-holder"><span>Design</span></div>
							</div>
							<div class="item" :class="{ active: activedElem === 2 }" @mouseenter="handleMouseEnter(2)">
								<div class="item-holder"><span>Branding</span></div>
							</div>
							<div class="item" :class="{ active: activedElem === 3 }" @mouseenter="handleMouseEnter(3)">
								<div class="item-holder"><span>Sites</span></div>
							</div>
							<div class="item" :class="{ active: activedElem === 4 }" @mouseenter="handleMouseEnter(4)">
								<div class="item-holder"><span>3D Motion</span></div>
							</div>
							<div class="item" :class="{ active: activedElem === 5 }" @mouseenter="handleMouseEnter(5)">
								<div class="item-holder"><span>Mobile app.</span></div>
							</div>
						</div>
					</div>
				</div>

				<div class="bottom-text-wrap">
					<div class="container">
						<div class="bottom-left-text">
							<span>our <br />services</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
